import { render, staticRenderFns } from "./ListWebinar.vue?vue&type=template&id=c2ec27ee&"
import script from "./ListWebinar.vue?vue&type=script&lang=js&"
export * from "./ListWebinar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports